module.exports = __webpack_public_path__ + "static/media/valor1.1632b9c8.png";